import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "contact-us-container" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  key: 0,
  class: "success-message"
}
const _hoisted_7 = {
  key: 1,
  class: "error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("h1", null, "Contact Us", -1)),
    _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
      class: "contact-form"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("label", { for: "name" }, "Your Name", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
          type: "text",
          id: "name",
          placeholder: "Enter your name",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.form.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { for: "email" }, "Email Address", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
          type: "email",
          id: "email",
          placeholder: "Enter your email",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.form.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { for: "subject" }, "Subject", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.subject) = $event)),
          type: "text",
          id: "subject",
          placeholder: "Subject of your message",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.form.subject]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[8] || (_cache[8] = _createElementVNode("label", { for: "message" }, "Message", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.message) = $event)),
          id: "message",
          placeholder: "Write your message",
          rows: "5",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.form.message]
        ])
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("button", {
        type: "submit",
        class: "submit-btn"
      }, "Send Message", -1))
    ], 32),
    (_ctx.isSuccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[10] || (_cache[10] = [
          _createElementVNode("p", null, "Thank you for reaching out! We will get back to you soon.", -1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[11] || (_cache[11] = [
          _createElementVNode("p", null, "Oops! Something went wrong. Please try again later.", -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}